import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to the top whenever the route changes. Without this, React
 * Router preserves scroll position across navigations — so clicking "Continue
 * to the store" from the bottom of /manifesto would land the visitor at the
 * bottom of /store too.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
